module.exports = __webpack_public_path__ + "img/ab-bottom-id.846cb9f2.png";